angular.module 'zc.users'

.controller 'EditUserCtrl', ($scope, $stateParams, $translate, Environment, Page, Devise, user) ->
  Page.setBodyClass ''

  $translate('users.controllers.editController.updateUserInformation').then (translation) ->
    Page.setTitle translation

  $scope.availableLanguages = $translate.getAvailableLanguageKeys();

  $scope.user =
    full_name: user.full_name
    email: user.email
    lang: user.lang
  $scope.isSaving = false

  $scope.save = (user) ->
    $scope.isSaving = true
    Devise.updateInfo user
    .finally ->
      $scope.isSaving = false
      $scope.form.$setPristine()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/controllers/edit_controller.js.coffee